var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "15px",
    viewBox: "0 0 8 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "home-V2",
    transform: "translate(-1354.000000, -2571.000000)",
    fill: "#081420",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(0.000000, 2511.551724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1360.8,67.0304 L1358.7336,67.0304 L1358.7336,74.4272 L1355.6512,74.4272 L1355.6512,67.0304 L1354.2008,67.0304 L1354.2008,64.42 L1355.6512,64.42 L1355.6512,62.716 C1355.58738,61.8805615 1355.89158,61.0589122 1356.48405,60.4664471 C1357.07651,59.873982 1357.89816,59.5697845 1358.7336,59.6336 L1361.0184,59.6336 L1361.0184,62.172 L1359.3864,62.172 C1359.19852,62.1665413 1359.01774,62.2439478 1358.89203,62.3836796 C1358.76631,62.5234113 1358.70838,62.7113405 1358.7336,62.8976 L1358.7336,64.4176 L1361.0536,64.4176 L1360.8,67.0304 Z",
    id: "Path_13-Copy"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFb);
export default __webpack_public_path__ + "static/media/ic_fb.0bd9cc6a.svg";
export { ForwardRef as ReactComponent };